import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";

import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { useState } from "react";
import Modal1 from "../modals/Modal1";
import createDocApi from "../api/database/createDocApi";
import { files, folder } from "jszip";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import { EasySwitch } from "../textfields/EasySwitch";
import WarningButton from "../buttons/WarningButton";
import { getFlutterTime } from "../models/DataFunctions";
import UploadRapportSlot from "../api/upload/UploadRapportSlot";
import FactureSlotVisualisateur from "./FactureSlotVisualisateur";
import UploadFactureSlot from "../api/upload/UploadFactureSlot";
import SlotRapportVisualisateur from "./SlotRapportVisualisateur";
import getTemporaryUrlV2 from "../api/getTemporaryUrlV2";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";

const ReglementConstructorClient = ({
  orgData,
  userData,
  folderData,
  clientData,
  reglement,
  setReglement,
  slots,
  setslots,

  handleUpdateReglement,
  handleFetchData,

  loadingTransfer,
  setLoadingTransfer,
  transferFiles,
  dropped_exists,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const theme = useTheme();
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const handleLoadInvoice = async (invoice) => {
    if (invoice.file.id) {
      setLoadingInvoice(invoice.file.id);
      const token = await getOrRefreshFirebaseToken();
      let refreshed_url = await getTemporaryUrlV2(
        invoice.file.id,
        token,
        prefix
      );
      if (refreshed_url) {
        window.open(refreshed_url, "_blank");
      } else {
        handleClickVariant("Impossible de charger le fichier", "error");
      }
      setLoadingInvoice(false);
    }
  };
  return (
    <div className="flex flex-col h-fit gap-2 justify-end items-start w-full">
      <div className="border-1 border-shadow_10 h-fit rounded-lg flex flex-col p-1 gap-1 w-full">
        <div className="flex flex-col gap-1 text-h3 text-black h-fit p-1">
          Emplacement de rapports
          <div className="flex flex-col gap-2 p-1">
            {folderData.invoices?.map((invoice) => (
              <div className="bg-white px-2 py-1 flex flex-row justify-between gap-1 rounded-full  text-h4 text-shadow_50 border-1 border-shadow_10">
                <div
                  onClick={() => handleLoadInvoice(invoice)}
                  className="hover:text-indigo-500 hover:underline cursor-pointer"
                >
                  {invoice.file.name?.substring(0, 30)}
                </div>
                {loadingInvoice === invoice.file.id && (
                  <SmallSpinner></SmallSpinner>
                )}
              </div>
            ))}

            {slots?.map((slot, index) => (
              <div
                key={index}
                className={`flex flex-col gap-1 relative border-1 text-h2 ${slots[index]?.state === "unlocked" ? "bg-teal-50 border-teal-300 " : "bg-slate-100 border-slate-300"}  rounded-xl p-2`}
              >
                {" "}
                <div className=" w-fit text-h3 text-indigo-500 font-semibold">
                  {slots[index]?.title ||
                    "emplacement de rapport " + (index + 1)}
                </div>
                <div className="flex flex-row gap-4 relative">
                  <div className="flex flex-col gap-2 p-1 w-c150 min-w-c150 ">
                    <div className="text-h3 text-shadow_50 ">Facture </div>

                    <div className="flex flex-row gap-2">
                      {!slots[index]?.facture_file && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Pas de facture
                        </div>
                      )}
                      {slots[index]?.facture_file && (
                        <div className=" text-h4  text-shadow_50  w-fit">
                          {slots[index]?.facture_file?.name}
                        </div>
                      )}
                    </div>
                    {slots[index]?.facture_file && (
                      <FactureSlotVisualisateur
                        folder={folderData}
                        slot_id={slots[index].id}
                        orgData={orgData}
                        prefix={prefix}
                      ></FactureSlotVisualisateur>
                    )}
                  </div>
                  <div className="flex-grow flex flex-col gap-2  rounded-lg p-1 border-shadow_10">
                    <div className="text-h3 text-shadow_50">Rapports </div>

                    <div className="flex flex-row gap-2 ">
                      {(!slots[index]?.files ||
                        slots[index]?.files?.length === 0) && (
                        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
                          <Icon1
                            icon_name="linked_file"
                            size={20}
                            fill={"grey"}
                          ></Icon1>
                          Pas de rapports
                        </div>
                      )}
                      {slots[index]?.files?.length > 0 && (
                        <div className=" text-h4 flex flex-col gap-1 text-shadow_50  w-fit">
                          {slots[index]?.files?.map((file, index) => (
                            <div
                              className="  border-l-1 border-green-300 rounded-sm px-1"
                              key={index}
                            >
                              {file.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {slots[index]?.files?.length > 0 &&
                      slots[index]?.state === "unlocked" && (
                        <SlotRapportVisualisateur
                          folder={folderData}
                          userData={userData}
                          slot_id={slots[index].id}
                          orgData={orgData}
                          prefix={prefix}
                          handleUpdate={handleFetchData}
                        ></SlotRapportVisualisateur>
                      )}
                  </div>{" "}
                  <div className="absolute top-1 right-1 text-h3 text-shadow_50 flex flex-row justify-end w-fit gap-1 ">
                    <div className="flex flex-col gap-2 items-end w-fit">
                      {slots[index]?.state === "unlocked" && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400">
                            Débloqué
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}
                      {slots[index]?.downloaded === true && (
                        <div className="flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-green-400 ">
                            Reçu
                          </div>
                          <Icon1
                            icon_name="done2"
                            size={18}
                            fill={"#4ade80"}
                          ></Icon1>
                        </div>
                      )}
                      {slots[index]?.state === "locked" && (
                        <div className="absolute top-1 right-1 flex flex-row gap-1 items-center w-full justify-end ">
                          <div className="font-semibold text-blue-500">
                            Verrouillé
                          </div>
                          <Icon1
                            icon_name="lock"
                            size={18}
                            fill={"#3b82f6"}
                          ></Icon1>
                        </div>
                      )}{" "}
                    </div>{" "}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default ReglementConstructorClient;
